<template>
    <b-container>
         <h1 class="title">Class</h1>
         <b-row>
            <b-col>
                 <h6 class="subtitle">Class Name</h6>
                 <b-form-input v-model="name" placeholder="Enter class name"></b-form-input>

                 <h6 class="subtitle mt-3">Assigned class Teacher</h6>
                 <b-form-input disabled v-model="teacherName"></b-form-input>

                 <h6 class="subtitle mt-3">Choose Class Teacher</h6>
                 <group-teacher-search></group-teacher-search>
             </b-col>
             <b-col>
                  <b-col>
        <h6 class="subtitle">Assign Teacher</h6>
        <b-form-group>
        
          <div >
            <b-col>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    v-model="teacherfilter"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-btn
                      :disabled="!teacherfilter"
                      @click="teacherfilter = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
                <b-table
                v-cloak
                responsive
                :fields="groupTeacherFields"
                :items="teacherTable"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="teacherCurrentPage"
                :per-page="perPage"
                :filter="teacherfilter"
                @filtered="onSelectedTeacherFiltered"
                >
                <template slot="cell(teacher_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditTeacher', params: { id: row.item.uuid } }"
                    >{{ row.item.name }}</b-link
                    >
                    <br />
                </template>
                <template slot="cell(id)" slot-scope="row">
                    <b-link
                    v-if="isAdmin || isSRC"
                    class="delete"
                    @click.stop="assignTeacher(row.item)"
                    >Assign</b-link
                    >
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                            <b-pagination
                            :total-rows="teacherTable.length || 0"
                            :per-page="perPage"
                            v-model="teacherCurrentPage"
                            class="my-0"
                            />
                        </b-col>
                        </b-row>
                    </div>
                    </b-form-group>
                </b-col>
             </b-col>
         </b-row>
         <!-- Import teacher -->

         <div class="mb-3">
          <b-form-checkbox
            id="checkbox-1"
            v-model="status"
            name="checkbox-1"
            value=true
            unchecked-value=false
            v-if="!isEditMode"
          >
            Import Students
          </b-form-checkbox>
          
        </div>
         <b-row v-if="status=='true'">
             <b-col>
                 <group-teacher-search></group-teacher-search>
             </b-col>
             <b-col>
                  <b-col>
        <h6 class="subtitle">Teachers currently in the Group</h6>
        <b-form-group>
        
          <div >
            <b-col>
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    v-model="filteredResults"
                    placeholder="Type to Search"
                  />
                  <b-input-group-append>
                    <b-btn
                      :disabled="!filteredResults"
                      @click="filteredResults = ''"
                      >Clear</b-btn
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
                <b-table
                v-cloak
                responsive
                :fields="groupTeacherFields"
                :items="teacherTable"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filteredResults"
                @filtered="filteredTeachers"
                >
                <template slot="cell(teacher_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditTeacher', params: { id: row.item.uuid } }"
                    >{{ row.item.name }}</b-link
                    >
                    <br />
                </template>
                <template slot="cell(id)" slot-scope="row">
                    <b-link
                    v-if="isAdmin || isSRC"
                    class="delete"
                    @click.stop="selectTeacher(row.item.uuid)"
                    >Select</b-link
                    >
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                            <b-pagination
                            :total-rows="teacherTable.length || 0"
                            :per-page="perPage"
                            v-model="currentPage"
                            class="my-0"
                            />
                        </b-col>
                        </b-row>
                    </div>
                    </b-form-group>
                </b-col>
             </b-col>
         </b-row>

         <b-row>
             <b-col v-if="!isEditMode">
                  <b-form-group
                    label="Filter"
                    label-for="filter-input"
                    label-cols-sm="1"
                    label-size="sm"
                    class="mb-0"
                    >
                    <b-input-group size="sm">
                        <b-form-input
                        id="filter-input"
                        v-model="filter"
                        type="search"
                        placeholder="Type to Search"
                        ></b-form-input>

                        <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="students"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="studentCurrentPage"
                :per-page="perPage"
                :filter="filter"
                @filtered="onStudentFiltered"
                >
                <template slot="cell(first_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditStudent', params: { id: row.item.student_uuid } }"
                    >{{ row.item.first_name }} {{ row.item.last_name }}</b-link
                    >
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p>
                    <p class="small-date">district: {{ row.item.region }}</p> -->
                </template>
                 <template slot="cell(sex)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.sex }}</p>
                </template>
                <template slot="cell(student_uuid)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <b-link
                    v-if="isAdmin || isSRC"
                    class="delete"
                    @click.stop="selectStudent(row.item)"
                    >Add</b-link
                    >
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination
                    :total-rows="students.length || 0"
                    :per-page="perPage"
                    v-model="studentCurrentPage"
                    class="my-0"
                    />
                </b-col>
                </b-row>

             </b-col>
             <!-- selected students table -->
              <b-col>
                  <b-form-group
                    label="Filter"
                    label-for="filter-input"
                    label-cols-sm="1"
                    label-size="sm"
                    class="mb-0"
                    >
                    <b-input-group size="sm">
                        <b-form-input
                        id="filter-input"
                        v-model="selectedStudentfilter"
                        type="search"
                        placeholder="Type to Search"
                        ></b-form-input>

                        <b-input-group-append>
                        <b-button :disabled="!selectedStudentfilter" @click="selectedStudentfilter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>

                <b-table
                v-cloak
                responsive
                :fields="fields"
                :items="selectedStudents"
                :striped="true"
                :bordered="true"
                :hover="true"
                stacked="md"
                :current-page="studentSelectedCurrentPage"
                :per-page="perPage"
                :filter="selectedStudentfilter"
                @filtered="onSelectedStudentFiltered"
                >
                <template slot="cell(first_name)" slot-scope="row">
                    <b-link
                    @click.stop="stopClick"
                    :to="{ name: 'EditStudent', params: { id: row.item.student_uuid } }"
                    >{{ row.item.first_name }} {{ row.item.last_name }}</b-link
                    >
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p>
                    <p class="small-date">district: {{ row.item.region }}</p> -->
                </template>
                 <template slot="cell(sex)" slot-scope="row">
                   
                    <br />
                    <!-- <p class="small-date">country: {{ row.item.country }}</p> -->
                    <p class="small-date"> {{ row.item.sex }}</p>
                </template>
                <template slot="cell(student_uuid)" slot-scope="row">
                   
                    <br />
                  
                    <b-link
                    v-if="isAdmin || isSRC"
                    class="delete"
                    @click.stop="removeStudent(row.item)"
                    >remove</b-link
                    >
                </template>
                </b-table>
                <b-row>
                <b-col md="6" class="my-1">
                    <b-pagination
                    :total-rows="selectedStudents.length || 0"
                    :per-page="perPage"
                    v-model="studentSelectedCurrentPage"
                    class="my-0"
                    />
                </b-col>
                </b-row>

             </b-col>
         </b-row>

         <confirm-submit v-if="isAdmin || isSRC"></confirm-submit>
          <b-button
            v-if="isAdmin || isSRC"
            :size="'lg'"
            :variant="'primary'"
            class="app_school_btn mb-4"
            @click.prevent="updateClass"
            :disabled="isDisabled"
          >Edit Class</b-button>
    </b-container>
</template>
<script>
import { mapGetters,mapActions } from "vuex";
import TeacherService from "../services/TeacherService";
import ClassService from "../services/ClassService";
import ConfirmSubmit from "@/components/ConfirmSubmit";
import GroupTeacherSearch from "../components/GroupTeacherSearch";
import Breadcrumb from "@/components/Breadcrumb";
import { flash } from "../mixins/flashes";
import { scrollTo } from "../mixins/scrollTo";


export default {
    name:"EditClass",
    mixins: [flash, scrollTo],
    components:{GroupTeacherSearch,ConfirmSubmit},
     data() {
        return {
             fields: [
                { key: "first_name", label: "Name", sortable: true },
                { key: "sex", label: "Sex" },
                { key: "student_uuid", label: "Action" },
            ],
             groupTeacherFields: [
                { key: "teacher_name", label: "name", sortable: true },
                { key: "id", label: "Select Teacher" },
            ],
            classData:null,
            teachers:[],
            students:[],
            name:"",
            filteredResults: null,
            filter: null,
            selectedStudentfilter: null,
            teacherfilter: null,
            currentPage: 1,
            studentCurrentPage: 1,
            teacherCurrentPage: 1,
            studentSelectedCurrentPage: 1,
            selectedStudents:[],
            studentIds:[],
            perPage : 5,
            teacher:null,
            status: false,
            selectedTeacher:null,
            teacherName:"",
            isDisabled: false,
            isEditMode: false
        };
    },
    methods:{
        ...mapActions({
            DELETE_TEACHER: "groups/DELETE_TEACHER",
            GET_GROUP_TEACHERS: "groups/GET_GROUP_TEACHERS",
        }),
        stopClick() {},
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        onStudentFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.studentCurrentPage = 1;
        },
        onSelectedStudentFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.studentSelectedCurrentPage = 1;
        },
        onSelectedTeacherFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.teacherCurrentPage = 1;
        },
        async fetchTeacherStudents(){
            var students = await TeacherService.fetchTeacherStudents({
                id: this.teacher,
            });   
        },
        async selectTeacher(val){
            this.teacher = val;
            var students = await TeacherService.fetchTeacherStudentsById(val);
            this.students = students.data.students;
        },
        selectStudent(val){
            this.selectedStudents.push(val);
            this.studentIds.push(val.student_uuid);
            this.students.forEach((element,index) => {
                if(element.student_uuid == val.student_uuid){
                this.students.splice(index,1);
                }
            });
        },
        assignTeacher(val){
            this.selectedTeacher = val;
            this.teacherName = val.name;
        },
        removeStudent(val){
          if(!this.isEditMode){
             var itemIndex;
             this.selectedStudents.forEach((element,index) => {
                if(element.student_uuid == val.student_uuid){
                     itemIndex = index;
                }
             });
            this.students.push(val);
            this.selectedStudents.splice(itemIndex,1);
            this.studentIds.splice(itemIndex,1);
          }else{
            this.updateClassStudent(val);
          }

        },
        async updateClass() {
          if (!this.$store.state.confirmed) {
            alert("Please confirm the information above is correct");
            return;
          }
          if (
            this.selectedTeacher === "" ||
            this.name === ""
          ) {
            this.scrollTo(0, 0);
            this.flashError();
          } else {
            this.isDisabled = true;
            
            if(!this.isEditMode){
              var postData = {classForm:this.name,students:this.studentIds,teacherId:this.selectedTeacher.uuid};
              await ClassService.addClass(postData);
              this.scrollTo(0, 0);
              this.flashSuccess();
              await this.$store.commit("resetConfirmed");
              setTimeout(() => this.$router.push({ name: "ClassList" }), 1500);
            }else{
              var teacherIdTmp = (this.selectedTeacher) ? this.selectedTeacher.uuid : null;
              var postData = {classId: this.classData.id,className:this.name,teacherId: teacherIdTmp,classTeacherId:this.classData.teacherId};
              await ClassService.editClass(this.classData.uuid,postData);
              await this.$store.commit("resetConfirmed");
            }
          }
        },
      async updateClassStudent(val){
        const payload = {
          id:val.student_class_id,
          active:!val.student_class_active
        }
        await ClassService.updateClassStudent(payload);
      }
    },
    computed: {
    ...mapGetters({
      teachers: "groups/groupTeachersObj",
      isAdmin: "auth/isAdmin",
       isSRC: "auth/isSRC",
    }),
    add() {
      return this.$route.path.includes("/add") ? true : false;
    },
    groupTeachers: {
      get() {
        return this.$store.state.groups.groupTeachers;
      },
    },
    groupTeachersNames: {
      get() {
        return this.$store.state.groups.group.teacher_names;
      },
    },
    groupTeachersIds: {
      get() {
        return this.$store.state.groups.group.teachers;
      },
    },
    teacherTable() {
     // if (!this.$store.state.groups.group.openTab) {
    //   if (!this.add) {
    //     const teachers = this.groupTeachers.map((k) => ({
    //       id: k.id,
    //       uuid: k.uuid,
    //       name: `${k.first_name} ${k.last_name}`,
    //       active: k.active,
    //     }));
    //     return teachers;
    //   } else {
        
        const ids = this.groupTeachersIds;
        const teachers = this.groupTeachersNames.map(function(obj, index) {
          return {
            id: null,
            uuid: ids[index],
            name: obj,
            active: true,
          };
        });
        return teachers;
    //   }
    },
  },
 async created(){
        if(this.$router.currentRoute.params.id){
          var classId = this.$router.currentRoute.params.id;
          this.isEditMode = true;
          var classDetailsData = await ClassService.getClassById(classId);
          var students = await ClassService.getClassStudents(classId);
          var classDetail = classDetailsData.data.results[0];
          this.classData = classDetail;
          this.teacherName = classDetail.teacher_name;
          // this.selectedTeacher = classDetail.teacher_uuid;
          this.name = classDetail.name;
          this.selectedStudents = students.data.results;
         
        }
    }
}
</script>